import React from 'react'
// libs
import { FieldArray, reduxForm } from 'redux-form'
// components
import { Button, BUTTON_LAYOUTS } from 'components/UI'
import { ReduxInput, ReduxSwitch } from 'components/FormElements/ReduxForm'
import renderIpAddresses from '../ApiClientCreateModal/fields/IpAddressList'
// context
import { ApiClientsPageContext } from 'containers/ApiClients/layers/API'
// constants
import { Forms } from 'constants/forms'
// types
import { InjectedFormProps } from 'redux-form/lib/reduxForm'
// views
import { Actions, Form } from './views'
// utils
import { handleError } from 'utils/errors/handlers'
import { required } from 'utils/validators'

const nameValidators = [required]

const cleanIpList = (list?: string[]): string[] => (list || []).map((ip) => ip.trim()).filter(Boolean)

interface Props {
  clientId: string
  hideModal: () => void
}

const UpdateForm: React.FC<InjectedFormProps<any, Props> & Props> = ({
  valid,
  clientId,
  hideModal,
  submitting,
  handleSubmit
}) => {
  const { updateApiClient } = React.useContext(ApiClientsPageContext)

  const handleFormSubmit = async (data: any) => {
    try {
      await updateApiClient({
        id: clientId,
        name: data.name,
        allowedIpRanges: cleanIpList(data.allowedIpRanges),
        active: !!data.active
      })

      hideModal()
    } catch (error) {
      handleError(error, 'ApiClientUpdateModal.handleFormSubmit')
    }
  }

  return (
    <Form onSubmit={handleSubmit(handleFormSubmit)}>
      <ReduxSwitch name='active' label='Active' preventInitialChange />
      <ReduxInput name='name' label='Name' validate={nameValidators} />
      <FieldArray name='allowedIpRanges' component={renderIpAddresses} />

      <Actions>
        <Button type='submit' layout={BUTTON_LAYOUTS.PURPLE} disabled={!valid || submitting} isLoading={submitting}>
          Save
        </Button>
        <Button type='button' layout={BUTTON_LAYOUTS.WHITE} onClick={hideModal}>
          Cancel
        </Button>
      </Actions>
    </Form>
  )
}

export default reduxForm<any, Props>({
  form: Forms.API_CLIENT_UPDATE_FORM,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false
})(UpdateForm)
